import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import delete_outline_black_24dp from '../assets/delete_outline_black_24dp.svg';
import { Alert, Button, Col, Container, Row } from 'react-bootstrap'

// import '../css/react-list-editable.css'

class EditableList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: props.list,
            newInputID: '',
            newInputBEZEICHNUNG: '',
            newInputDELETED: 0,
            msg: ''
        };
        this.myRef = createRef();
    }

    matchExact(r, str) {
        var match = str.match(r);
        return match && str === match[0];
     }

    handleListItemChange = (event, index) => {
        const newList = [...this.state.list];
        newList[index][event.target.name] = event.target.value;
        this.setState(
            {
                list: newList
            },
            () => {
                this.props.onListChange(this.state.list);
            }
        );
    };

    deleteItem = (index) => {
        const newList = [...this.state.list];
        newList.splice(index, 1);
        this.setState(
            {
                list: newList
            },
            () => {
                this.props.onListChange(this.state.list);
            }
        );
    };

    handleDeleteButtonClick = (index) => {
        return (event) => {
            // In order for the form not to be submitted
            event.preventDefault();
            this.deleteItem(index);
        }
    };

    getList = () => {
        return this.state.list.map((elem, index) => {
            return (
                <Col key={'Col-' + index}>
                    <li key={'li-' + index} className='input-field-container'>
                        <input key={'ID-' + index}
                            className='input-field-small'
                            type='text'
                            name='ID'
                            value={elem.ID}
                            readOnly={true}
                            placeholder={this.props.placeholder}
                        />
                        <input key={'Bez-' + index}
                            className='input-field'
                            type='text'
                            name='BEZEICHNUNG'
                            value={elem.BEZEICHNUNG}
                            placeholder={this.props.placeholder}
                            onChange={e => {
                                this.handleListItemChange(e, index);
                            }}
                        />
                        <Button key={'Del-' + index}
                            onClick={this.handleDeleteButtonClick(index)}
                            variant='outline-light'>
                            <img key={'DelImg-' + index}
                                className='delete-img'
                                src={delete_outline_black_24dp}
                                alt='Delete' />
                        </Button>
                    </li>
                </Col>
            );
        });
    };

    onChange = (event) => {
        //        console.log(event)
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    onKeyUp = (event) => {
        if (event.key === 'Enter' && event.target.value.trim(' ').length > 0 && this.state.newInputID.trim().length > 0 && this.state.newInputBEZEICHNUNG.trim().length > 0) {
            const newItem = { 'ID': this.state.newInputID, 'BEZEICHNUNG': this.state.newInputBEZEICHNUNG, 'DELETED': this.state.newInputDELETED }
            // console.log(newList)
            
            console.log(this.state.newInputID)

            const re = this.props.IDRegexp;
            if (!this.matchExact(re, this.state.newInputID)) {
                this.setState({ ...this.state, msg: `Die ID muss die Form ${re} haben.` })
                return;
            }
            const knownIDs = this.state.list.map(item => item.ID);
            if (knownIDs.includes(this.state.newInputID)) {
                this.setState({ ...this.state, msg: `Diese ID wird bereits verwendet.` })
                return;
            }
            const newList = [...this.state.list];
            this.setState(
                {
                    //                    list: newList.concat(event.target.value),
                    list: newList.concat(newItem),
                    newInputID: '',
                    newInputBEZEICHNUNG: '',
                    newInputDELETED: 0,
                    msg: ''
                },
                () => {
                    this.props.onListChange(this.state.list);
                }
            );
        }
    };

    onBlur = (event) => {
        //        console.log('onBlur:', event.target.name, event.target.value)
        if (event.target.name === 'newInputBEZEICHNUNG' && event.target.value !== '') {
            this.setState({ ...this.state, msg: 'Bitte erst mit Eingabe bestätigen.' })
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.shouldReload()) {
            //            console.log('componentDidUpdate', prevState.list)
            this.setState({
                list: this.props.list,
                newInputID: '',
                newInputBEZEICHNUNG: '',
                newInputDELETED: 0,
                msg: ''
            });
        }
    }
 
    render() {
        //        console.log('render EditableList', this.props.list)
        return (
            <Container fluid>
                <div className='react-list-editable' key='edit-list'>
                    <ul className={this.props.showBullets ? '' : 'withoutBullet'} key='List'>
                        <Row xs={1} md={3} lg={3}>
                            {this.getList()}
                        </Row>
                        <Row>
                            <Col>
                                <li className='input-field-container' key='inp-new-ID-Bez'>
                                    <input key='newInputID'
                                        name='newInputID'
                                        className='input-field-small new-input-field-small'
                                        onChange={this.onChange}
                                        onKeyUp={this.onKeyUp}
                                        placeholder='ID'
                                        value={this.state.newInputID} />
                                    <input key='newInputBEZEICHNUNG'
                                        name='newInputBEZEICHNUNG'
                                        ref={this.myRef}
                                        className='input-field new-input-field'
                                        onBlur={this.onBlur}
                                        onChange={this.onChange}
                                        onKeyUp={this.onKeyUp}
                                        placeholder='BEZEICHNUNG: Neuer Eintrag'
                                        value={this.state.newInputBEZEICHNUNG} />
                                    <Button className='delete-btn-invisible' key="del-btn-new"
                                    >
                                        <img key={'delImgNew'}
                                            className='delete-img'
                                            src={delete_outline_black_24dp}
                                            alt='Delete' />
                                    </Button>
                                    {this.state.msg > '' && <Alert variant='danger'>{this.state.msg}</Alert>}
                                </li>
                            </Col>
                        </Row>
                    </ul>
                </div>
            </Container>
        );
    }
}

EditableList.propTypes = {
    list: PropTypes.array.isRequired,
    showBullets: PropTypes.bool,
    onListChange: PropTypes.func.isRequired
};

EditableList.defaultProps = {
    list: [],
    showBullets: true
};

export default EditableList;
